
// import React, { useState, useEffect, useCallback, useRef } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { Grid, Column, Tile, InlineNotification } from "@carbon/react";
// import { callApi } from "../../services/apiService";

// import RentForm from "../../components/property/residential/rentForm/RentForm";
// import ResaleForm from "../../components/property/residential/resaleForm/ResaleForm";
// import PGForm from "../../components/property/residential/pgHostelForm/PGForm";
// import FlatmatesForm from "../../components/property/residential/flatmatesForm/FlatmatesForm";
// import CommercialRentForm from "../../components/property/commercial/rent/CommercialRentForm";
// import SaleForm from "../../components/property/commercial/sale/SaleForm";
// import LandResaleForm from "../../components/property/landPlot/ResaleForm";

// export default function PostProperty() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const params = new URLSearchParams(location.search);

//   const type = params.get("type") || "";
//   const ad = params.get("ad") || "";
//   const property_uuid = params.get("property_uuid") || "";
//   const request_type = params.get("request_type") || "form_attributes";
//   const urlFormType = params.get("form_type") || "";

//   const [currentStep, setCurrentStep] = useState(1);
//   const [propertyDetails, setPropertyDetails] = useState({});
//   const [formMode, setFormMode] = useState("add");
//   const [saveSuccess, setSaveSuccess] = useState(false);
//   const [lastSavedStep, setLastSavedStep] = useState(0);

//   const hasFetchedRef = useRef(false);
//   const formDataRef = useRef({});
//   const completedStepsRef = useRef(new Set()); // Track completed steps

//   // Add debug logging
//   console.log('🔍 PostProperty State:', {
//     currentStep,
//     lastSavedStep,
//     formMode,
//     urlFormType,
//     completedSteps: Array.from(completedStepsRef.current),
//     shouldBeEdit: lastSavedStep >= currentStep || completedStepsRef.current.has(currentStep)
//   });

//   const pickFirst = (v) => (Array.isArray(v) ? v[0] : v);

//   const flattenData = useCallback((row) => {
//     if (!row || typeof row !== "object") return {};
//     const attrs = row.attributes || {};
//     const area = row.area_information || {};
//     return {
//       ...row,
//       ...attrs,
//       ...area,
//       builtUpArea: area.built_up_area ?? "",
//       carpetArea: area.carpet_area ?? "",
//       measurementUnit: area.measurement_unit ?? "",
//       plotArea: area.plot_area ?? "",
//     };
//   }, []);

//   // FIXED: Enhanced computeFormTypeForStep with completed steps tracking
//   const computeFormTypeForStep = useCallback((step) => {
//     const backendEdit = lastSavedStep >= step;
//     const clientEdit = completedStepsRef.current.has(step);
//     const result = backendEdit || clientEdit ? "edit" : "add";
    
//     console.log('🧮 computeFormTypeForStep:', {
//       step,
//       lastSavedStep,
//       completedSteps: Array.from(completedStepsRef.current),
//       backendEdit,
//       clientEdit,
//       result
//     });
//     return result;
//   }, [lastSavedStep]);

//   // Update URL with form_type parameter
//   const updateUrl = useCallback(
//     (uuid, formType = null) => {
//       if (!uuid) return;
//       const q = new URLSearchParams();
//       if (type) q.set("type", type);
//       if (ad) q.set("ad", ad);
//       q.set("property_uuid", uuid);
//       q.set("request_type", request_type);
      
//       // Always set form_type based on current formMode or provided formType
//       const currentFormType = formType || formMode;
//       q.set("form_type", currentFormType);
      
//       console.log('🔗 updateUrl:', {
//         uuid,
//         formType: currentFormType,
//         currentStep,
//         formMode
//       });
      
//       navigate(`?${q.toString()}`, { replace: true });
//     },
//     [type, ad, request_type, navigate, formMode, currentStep]
//   );

//   const getResponseRows = (resp) => {
//     const root = resp?.data ?? resp;
//     // const rows = root?.data ?? root?.Data ?? null;
//     return root;
//   };

//   const fetchPropertyDetails = useCallback(
//     async (uuidParam, forceRefresh = false) => {
//       const uuid = uuidParam || property_uuid;
//       if (!uuid) return;
      
//       if (hasFetchedRef.current && !forceRefresh) {
//         return;
//       }

//       try {
//         const resp = await callApi(
//           "GET",
//           `/property_detail_attribute/?property_uuid=${uuid}&request_type=${request_type}`
//         );

//         const rows = getResponseRows(resp);
//         const row = pickFirst(rows);

//         if (!row) {
//           setPropertyDetails({});
//           return;
//         }

//         const flat = flattenData(row);
//         formDataRef.current = row;
//         setPropertyDetails(flat);

//         const flags = [
//           "step1_completed",
//           "step2_completed",
//           "step3_completed",
//           "step4_completed",
//           "step5_completed",
//           "step6_completed",
//         ];

//         const maxStep = flags.reduce(
//           (acc, key, i) => (row[key] ? i + 1 : acc),
//           0
//         );

//         console.log('📊 Fetched property step completion:', {
//           step1: row.step1_completed,
//           step2: row.step2_completed,
//           step3: row.step3_completed,
//           step4: row.step4_completed,
//           step5: row.step5_completed,
//           step6: row.step6_completed,
//           maxStep
//         });

//         // Update state
//         setLastSavedStep(maxStep);
        
//         // Also update completed steps from backend data
//         flags.forEach((key, index) => {
//           if (row[key]) {
//             completedStepsRef.current.add(index + 1);
//           }
//         });
        
//         hasFetchedRef.current = true;

//         // Set form mode based on current step and saved progress
//         const mode = computeFormTypeForStep(currentStep);
//         console.log('🔄 fetchPropertyDetails setting formMode:', {
//           currentStep,
//           maxStep,
//           completedSteps: Array.from(completedStepsRef.current),
//           mode
//         });
//         setFormMode(mode);

//         // Update URL with correct form_type
//         updateUrl(uuid, mode);
//       } catch (e) {
//         console.error("Failed to fetch property details:", e);
//         setPropertyDetails({});
//       }
//     },
//     [
//       property_uuid, 
//       request_type, 
//       flattenData, 
//       currentStep, 
//       updateUrl, 
//       computeFormTypeForStep
//     ]
//   );

//   const handleFormSaveSuccess = useCallback(
//     async (savedUUID, stepData = null, stepNumber = 1) => {
//       setSaveSuccess(true);

//       if (stepData) {
//         formDataRef.current = { ...formDataRef.current, ...stepData };
//         setPropertyDetails((p) => ({ ...p, ...stepData }));
//       }

//       // Update completed steps tracking
//       completedStepsRef.current.add(stepNumber);
      
//       // Update last saved step
//       const newLastSavedStep = Math.max(lastSavedStep, stepNumber);
//       setLastSavedStep(newLastSavedStep);
      
//       console.log('📈 PostProperty: Updated steps tracking:', {
//         stepNumber,
//         newLastSavedStep,
//         completedSteps: Array.from(completedStepsRef.current)
//       });

//       const uuidToUse = property_uuid || savedUUID || "";

//       if (uuidToUse) {
//         // Update URL with edit mode for the saved step
//         updateUrl(uuidToUse, "edit");
//       }

//       // Update form mode based on the new lastSavedStep
//       const newMode = computeFormTypeForStep(currentStep);
//       console.log('🔄 handleFormSaveSuccess updating formMode:', {
//         currentStep,
//         newLastSavedStep,
//         completedSteps: Array.from(completedStepsRef.current),
//         newMode
//       });
//       setFormMode(newMode);

//       // Force refresh to get latest data from server
//       if (uuidToUse) {
//         await fetchPropertyDetails(uuidToUse, true);
//       }

//       setTimeout(() => setSaveSuccess(false), 1800);
//     },
//     [property_uuid, currentStep, computeFormTypeForStep, updateUrl, fetchPropertyDetails, lastSavedStep]
//   );

//   const handleStepChange = useCallback(
//     (newStep, stepData = null) => {
//       if (stepData) {
//         formDataRef.current = { ...formDataRef.current, ...stepData };
//         setPropertyDetails((p) => ({ ...p, ...stepData }));
//       }

//       setCurrentStep(newStep);
      
//       // Set form mode based on the new step and saved progress
//       const newMode = computeFormTypeForStep(newStep);
//       console.log('➡️ handleStepChange updating formMode:', {
//         newStep,
//         lastSavedStep,
//         completedSteps: Array.from(completedStepsRef.current),
//         newMode
//       });
//       setFormMode(newMode);

//       if (property_uuid) {
//         // Update URL with correct form_type for the new step
//         updateUrl(property_uuid, newMode);
//       }
//     },
//     [property_uuid, computeFormTypeForStep, updateUrl, lastSavedStep]
//   );

//   // Sync formMode with lastSavedStep changes
//   useEffect(() => {
//     const newMode = computeFormTypeForStep(currentStep);
//     console.log('🔄 PostProperty useEffect updating formMode:', {
//       currentStep,
//       lastSavedStep,
//       completedSteps: Array.from(completedStepsRef.current),
//       newMode
//     });
//     setFormMode(newMode);
//   }, [currentStep, lastSavedStep, computeFormTypeForStep]);

//   // Initialize when property_uuid changes
//   useEffect(() => {
//     if (property_uuid && !hasFetchedRef.current) {
//       fetchPropertyDetails(property_uuid);
//     }
//   }, [property_uuid, fetchPropertyDetails]);

//   // Also update URL when formMode changes from URL parameter
//   useEffect(() => {
//     if (property_uuid && urlFormType && urlFormType !== formMode) {
//       console.log('🔄 URL form_type changed, updating state:', { urlFormType, formMode });
//       setFormMode(urlFormType);
//     }
//   }, [urlFormType, property_uuid, formMode]);

//   const headerTitle =
//     formMode === "edit" ? `Edit ${type} for ` : `Post ${type} for `;
//   const headerSubtitle = `${ad} `
//   //• Step ${currentStep} • ${formMode.toUpperCase()} mode • Last saved step: ${lastSavedStep}`;

//   const commonFormProps = {
//     property_uuid,
//     propertyDetails: formDataRef.current || propertyDetails,
//     isEditMode: formMode === "edit",
//     currentStep,
//     onStepChange: handleStepChange,
//     onSaveSuccess: handleFormSaveSuccess,
//     lastSavedStep: lastSavedStep,
//     request_type,
//     formMode,
//   };

//   const renderForm = () => {
//     const map = {
//       Residential: {
//         Rent: RentForm,
//         Resale: ResaleForm,
//         "PG/Hostel": PGForm,
//         Flatmates: FlatmatesForm,
//       },
//       Commercial: {
//         Rent: CommercialRentForm,
//         Sale: SaleForm,
//       },
//       "Land/Plot": {
//         Resale: LandResaleForm,
//       },
//     };

//     const FormComponent = map[type]?.[ad];
//     if (!FormComponent) {
//       return (
//         <InlineNotification
//           kind="error"
//           title="Invalid Property Type"
//           subtitle={`${type} - ${ad} is not valid`}
//         />
//       );
//     }

//     return <FormComponent {...commonFormProps} />;
//   };

//   return (
//     <Grid fullWidth>
//       <Column sm={4} md={8} lg={16}>
//         {saveSuccess }

//         <h1 style={{ marginBottom: 4 }}>{headerTitle}</h1>
//         <p style={{ marginBottom: 1}}>{headerSubtitle}</p>

//         <Tile
//         style={{ backgroundColor:"white" }}
        
//         >{renderForm()}</Tile>
//       </Column>
//     </Grid>
//   );
// }



import React, { useState, useEffect, useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid, Column, Tile, InlineNotification } from "@carbon/react";
import { callApi } from "../../services/apiService";

import RentForm from "../../components/property/residential/rentForm/RentForm";
import ResaleForm from "../../components/property/residential/resaleForm/ResaleForm";
import PGForm from "../../components/property/residential/pgHostelForm/PGForm";
import FlatmatesForm from "../../components/property/residential/flatmatesForm/FlatmatesForm";
import CommercialRentForm from "../../components/property/commercial/rent/CommercialRentForm";
import SaleForm from "../../components/property/commercial/sale/SaleForm";
import LandResaleForm from "../../components/property/landPlot/ResaleForm";
import { useUser } from "../../context/UserContext";

export default function PostProperty() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);

  const type = params.get("type") || "";
  const ad = params.get("ad") || "";
  const property_uuid = params.get("property_uuid") || "";
  const request_type = params.get("request_type") || "form_attributes";

  // Get logged-in user
const { user } = useUser();
const isVerifier = user?.role_name === "VERIFIER";

  const [currentStep, setCurrentStep] = useState(1);
  const [propertyDetails, setPropertyDetails] = useState({});
  const [formMode, setFormMode] = useState("add");
  const [lastSavedStep, setLastSavedStep] = useState(0);

  const formDataRef = useRef({});

  const flattenData = useCallback((row) => {
    if (!row || typeof row !== "object") return {};
    const attrs = row.attributes || {};
    const area = row.area_information || {};
    return {
      ...row,
      ...attrs,
      ...area,
      builtUpArea: area.built_up_area ?? "",
      carpetArea: area.carpet_area ?? "",
      measurementUnit: area.measurement_unit ?? "",
      plotArea: area.plot_area ?? "",
    };
  }, []);

  const computeFormTypeForStep = useCallback(
    (step) => (lastSavedStep >= step ? "edit" : "add"),
    [lastSavedStep]
  );

  const updateUrl = useCallback(
    (uuid, formType = null) => {
      if (!uuid) return;
      const q = new URLSearchParams();
      if (type) q.set("type", type);
      if (ad) q.set("ad", ad);
      q.set("property_uuid", uuid);
      q.set("request_type", request_type);
      q.set("form_type", formType || formMode);
      navigate(`?${q.toString()}`, { replace: true });
    },
    [type, ad, request_type, navigate, formMode]
  );

  const fetchPropertyDetails = useCallback(
    async (uuidParam) => {
      const uuid = uuidParam || property_uuid;
      if (!uuid) return;

      try {
        const resp = await callApi(
          "GET",
          `/property_detail_attribute/?property_uuid=${uuid}&request_type=${request_type}`
        );

        const rows = resp?.data ?? resp;
        const row = Array.isArray(rows) ? rows[0] : rows;

        if (!row) {
          setPropertyDetails({});
          return;
        }

        const flat = flattenData(row);
        formDataRef.current = row;
        setPropertyDetails(flat);

const flags = [
  "step1_completed",
  "step2_completed",
  "step3_completed",
  "step4_completed",
  "step5_completed",
  "step6_completed",
];

const maxStep = flags.reduce(
  (acc, key, index) => (row[key] ? index + 1 : acc),
  0
);

setLastSavedStep(maxStep);

        const mode = computeFormTypeForStep(currentStep);
        setFormMode(mode);
        updateUrl(uuid, mode);
      } catch (e) {
        console.error("Failed to fetch property details:", e);
        setPropertyDetails({});
      }
    },
    [property_uuid, request_type, flattenData, currentStep, updateUrl, computeFormTypeForStep]
  );

  const handleFormSaveSuccess = useCallback(
    async (savedUUID, stepData = null, stepNumber = 1) => {

      if (stepData) {
        formDataRef.current = { ...formDataRef.current, ...stepData };
        setPropertyDetails((p) => ({ ...p, ...stepData }));
      }

      const newLastSavedStep = Math.max(lastSavedStep, stepNumber);
      setLastSavedStep(newLastSavedStep);

      const uuidToUse = property_uuid || savedUUID || "";

      if (uuidToUse) {
        updateUrl(uuidToUse, "edit");
      }

      const newMode = computeFormTypeForStep(currentStep);
      setFormMode(newMode);

      if (uuidToUse) {
        await fetchPropertyDetails(uuidToUse);
      }

      setTimeout(() => {
  // action
}, 1500);
    },
    [property_uuid, currentStep, computeFormTypeForStep, updateUrl, fetchPropertyDetails, lastSavedStep]
  );

  const handleStepChange = useCallback(
    (newStep, stepData = null) => {
      if (stepData) {
        formDataRef.current = { ...formDataRef.current, ...stepData };
        setPropertyDetails((p) => ({ ...p, ...stepData }));
      }

      setCurrentStep(newStep);

      const newMode = computeFormTypeForStep(newStep);
      setFormMode(newMode);

      if (property_uuid) {
        updateUrl(property_uuid, newMode);
      }
    },
    [property_uuid, computeFormTypeForStep, updateUrl]
  );

  useEffect(() => {
    if (property_uuid) {
      fetchPropertyDetails(property_uuid);
    }
  }, [property_uuid, fetchPropertyDetails]);

const isPropertyEdit = Boolean(property_uuid);

const headerTitle =
  isPropertyEdit
    ? `Edit ${type} for `
    : `Post ${type} for `;
  const headerSubtitle = `${ad}`;

const commonFormProps = {
  property_uuid,
  propertyDetails: formDataRef.current || propertyDetails,

  // Verifier has the same add/edit access as other users
  isEditMode: formMode === "edit",

  // Optional: child forms can identify verifier if needed
  isVerifier,

  currentStep,
  onStepChange: handleStepChange,
  onSaveSuccess: handleFormSaveSuccess,
  lastSavedStep,
  request_type,
  formMode,
};

  const renderForm = () => {
    const map = {
      Residential: {
        Rent: RentForm,
        Resale: ResaleForm,
        "PG/Hostel": PGForm,
        Flatmates: FlatmatesForm,
      },
      Commercial: {
        Rent: CommercialRentForm,
        Sale: SaleForm,
      },
      "Land/Plot": {
        Resale: LandResaleForm,
      },
    };

    const FormComponent = map[type]?.[ad];
    if (!FormComponent) {
      return (
        <InlineNotification
          kind="error"
          title="Invalid Property Type"
          subtitle={`${type} - ${ad} is not valid`}
        />
      );
    }

    return <FormComponent {...commonFormProps} />;
  };

  return (
    <Grid fullWidth>
      <Column sm={4} md={8} lg={16}>

        <h1>{headerTitle}</h1>
        <p>{headerSubtitle}</p>

        <Tile style={{ backgroundColor: "white" }}>
          {renderForm()}
        </Tile>
      </Column>
    </Grid>
  );
}